import React from "react";
import "./agencies.style.sass";
import Divider from "../../assets/image/DIVIDER.png";
import {
	Table,
	ButtonToolbar,
	ButtonGroup,
	Button,
	Icon,
	IntlProvider,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
	selectCities,
	selectCity,
	selectListProvince,
	selectProvince,
} from "../../redux/site/site.selector";
import ProvinceData from "../../data/iranMap/iranData.json";
import Axios from "axios";
import { Setting } from "../../setting";
import {
	ChangeProvince,
	SetCities,
	SetCity,
	SetListProvince,
} from "../../redux/site/site.actions";
import { css } from "@emotion/react";
import GridLoader from "react-spinners/GridLoader";
import BeatLoader from "react-spinners/BeatLoader";

class AgenciesListComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			state: "",
			data: "",
			loading: true,
		};
	}

	componentDidMount() {
		Axios.get(`${Setting.apiUrl}api/state/list`).then((res) => {
			this.setState({
				state: res.data.data,
				loading: false,
			});
		});
		const { province, setListProvince, setCities } = this.props;
		Axios.get(
			`${Setting.apiUrl}api/representative/list?state=${parseInt(province)}`
		).then((res) => {
			let Arr = [];
			Arr = res.data.representatives;
			Arr.sort((a, b) => a.score - b.score);
			Arr.reverse();
			setListProvince(Arr);
			setCities(res.data.cities);
		});
	}

	handleClickCity = (cityId) => {
		const { province, city, setListProvince } = this.props;
		this.setState({
			loading: true,
		});
		Axios.get(
			`${Setting.apiUrl}api/representative/list?state=${parseInt(
				province
			)}&city=${cityId}`
		).then((res) => {
			setListProvince(res.data.representatives);
			this.setState({
				loading: false,
			});
		});
	};
	render() {
		const { Column, HeaderCell, Cell } = Table;
		const { province, cities, changeProvince, changeCity, listProvince } =
			this.props;
		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
			position: relative;
		`;

		const ImageCell = ({ rowData, dataKey, ...props }) => (
			<Cell {...props}>
				<div
					style={{
						width: "100%",
						borderRadius: 6,
						overflow: "hidden",
						display: "inline-block",
					}}
				>
					<img
						src={`${Setting.apiUrl}/${rowData[dataKey]}`}
						width="100%"
						style={{ objectFit: "cover" }}
					/>
				</div>
			</Cell>
		);
		return (
			<div className="agencies-list">
				<div className="agencies-title">
					<h4>
						{province && this.state.state ? (
							this.state.state.find((item) => item.id === parseInt(province))
								.name
						) : (
							<BeatLoader
								css={override}
								color="#FF8F3C"
							/>
						)}
					</h4>
				</div>
				<div className="agencies-body">
					<div className="btnGroup-boody">
						{cities
							? cities.map((item, i) => (
									<Button
										className="city-botton"
										key={i}
										onClick={() => this.handleClickCity(item.id)}
									>
										{item.name}
									</Button>
							  ))
							: null}
					</div>

					<img
						src={Divider}
						alt="Divider"
					/>
					{listProvince ? (
						<Table
							wordWrap
							rtl
							data={listProvince}
							cellBordered
							loading={this.state.loading}
							rowKey="code"
							height={350}
							renderEmpty={() => (
								<p className="agencies-empty-message">
									نمایندگی برای این استان وجود ندارد
								</p>
							)}
						>
							<Column>
								<HeaderCell>کد نمایندگی</HeaderCell>
								<Cell dataKey="code" />
							</Column>
							<Column>
								<HeaderCell>نام</HeaderCell>
								<Cell dataKey="full_name" />
							</Column>
							<Column>
								<HeaderCell>شهر</HeaderCell>
								<Cell dataKey="city" />
							</Column>
							<Column
								flexGrow={2}
								minWidth={250}
							>
								<HeaderCell>آدرس</HeaderCell>
								<Cell dataKey="address" />
							</Column>
							<Column>
								<HeaderCell>لوگو</HeaderCell>
								<ImageCell dataKey="logo" />
							</Column>
							<Column>
								<HeaderCell>امتیاز</HeaderCell>
								<Cell dataKey="score">
									{(rowData) => {
										return (
											<ul className="score-stars">
												{[...Array(5)].map((_, index) => (
													<li key={index}>
														{index < rowData?.score ? (
															<svg viewBox="0 0 22 22">
																<path
																	className="filled"
																	d="M16.66 21.67C16.13 21.67 15.45 21.5 14.6 21L11.61 19.23C11.3 19.05 10.7 19.05 10.4 19.23L7.4 21C5.63 22.05 4.59 21.63 4.12 21.29C3.66 20.95 2.94 20.08 3.41 18.08L4.12 15.01C4.2 14.69 4.04 14.14 3.8 13.9L1.32 11.42C0.0799956 10.18 0.179996 9.12001 0.349996 8.60001C0.519996 8.08001 1.06 7.16001 2.78 6.87001L5.97 6.34001C6.27 6.29001 6.7 5.97001 6.83 5.70001L8.6 2.17001C9.4 0.560007 10.45 0.320007 11 0.320007C11.55 0.320007 12.6 0.560007 13.4 2.17001L15.16 5.69001C15.3 5.96001 15.73 6.28001 16.03 6.33001L19.22 6.86001C20.95 7.15001 21.49 8.07001 21.65 8.59001C21.81 9.11001 21.91 10.17 20.68 11.41L18.2 13.9C17.96 14.14 17.81 14.68 17.88 15.01L18.59 18.08C19.05 20.08 18.34 20.95 17.88 21.29C17.63 21.47 17.23 21.67 16.66 21.67ZM11 17.59C11.49 17.59 11.98 17.71 12.37 17.94L15.36 19.71C16.23 20.23 16.78 20.23 16.99 20.08C17.2 19.93 17.35 19.4 17.13 18.42L16.42 15.35C16.23 14.52 16.54 13.45 17.14 12.84L19.62 10.36C20.11 9.87001 20.33 9.39001 20.23 9.06001C20.12 8.73001 19.66 8.46001 18.98 8.35001L15.79 7.82001C15.02 7.69001 14.18 7.07001 13.83 6.37001L12.07 2.85001C11.75 2.21001 11.35 1.83001 11 1.83001C10.65 1.83001 10.25 2.21001 9.94 2.85001L8.17 6.37001C7.82 7.07001 6.98 7.69001 6.21 7.82001L3.03 8.35001C2.35 8.46001 1.89 8.73001 1.78 9.06001C1.67 9.39001 1.9 9.88001 2.39 10.36L4.87 12.84C5.47 13.44 5.78 14.52 5.59 15.35L4.88 18.42C4.65 19.41 4.81 19.93 5.02 20.08C5.23 20.23 5.77 20.22 6.65 19.71L9.64 17.94C10.02 17.71 10.51 17.59 11 17.59Z"
																/>
															</svg>
														) : (
															<svg viewBox="0 0 22 22">
																<path d="M16.66 21.67C16.13 21.67 15.45 21.5 14.6 21L11.61 19.23C11.3 19.05 10.7 19.05 10.4 19.23L7.4 21C5.63 22.05 4.59 21.63 4.12 21.29C3.66 20.95 2.94 20.08 3.41 18.08L4.12 15.01C4.2 14.69 4.04 14.14 3.8 13.9L1.32 11.42C0.0799956 10.18 0.179996 9.12001 0.349996 8.60001C0.519996 8.08001 1.06 7.16001 2.78 6.87001L5.97 6.34001C6.27 6.29001 6.7 5.97001 6.83 5.70001L8.6 2.17001C9.4 0.560007 10.45 0.320007 11 0.320007C11.55 0.320007 12.6 0.560007 13.4 2.17001L15.16 5.69001C15.3 5.96001 15.73 6.28001 16.03 6.33001L19.22 6.86001C20.95 7.15001 21.49 8.07001 21.65 8.59001C21.81 9.11001 21.91 10.17 20.68 11.41L18.2 13.9C17.96 14.14 17.81 14.68 17.88 15.01L18.59 18.08C19.05 20.08 18.34 20.95 17.88 21.29C17.63 21.47 17.23 21.67 16.66 21.67ZM11 17.59C11.49 17.59 11.98 17.71 12.37 17.94L15.36 19.71C16.23 20.23 16.78 20.23 16.99 20.08C17.2 19.93 17.35 19.4 17.13 18.42L16.42 15.35C16.23 14.52 16.54 13.45 17.14 12.84L19.62 10.36C20.11 9.87001 20.33 9.39001 20.23 9.06001C20.12 8.73001 19.66 8.46001 18.98 8.35001L15.79 7.82001C15.02 7.69001 14.18 7.07001 13.83 6.37001L12.07 2.85001C11.75 2.21001 11.35 1.83001 11 1.83001C10.65 1.83001 10.25 2.21001 9.94 2.85001L8.17 6.37001C7.82 7.07001 6.98 7.69001 6.21 7.82001L3.03 8.35001C2.35 8.46001 1.89 8.73001 1.78 9.06001C1.67 9.39001 1.9 9.88001 2.39 10.36L4.87 12.84C5.47 13.44 5.78 14.52 5.59 15.35L4.88 18.42C4.65 19.41 4.81 19.93 5.02 20.08C5.23 20.23 5.77 20.22 6.65 19.71L9.64 17.94C10.02 17.71 10.51 17.59 11 17.59Z" />
															</svg>
														)}
													</li>
												))}
											</ul>
										);
									}}
								</Cell>
							</Column>
							<Column>
								<HeaderCell>نقشه</HeaderCell>
								<Cell>
									{(rowData) => (
										<a
											className="table-action-cell"
											href={`https://maps.google.com/maps?q=${rowData.lat},${rowData.lng}`}
											target="_blank"
											rel="noreferrer"
										>
											<Icon icon="map-o" />
										</a>
									)}
								</Cell>
							</Column>
						</Table>
					) : (
						<GridLoader
							size={15}
							margin={8}
							css={override}
							color="#FF8F3C"
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	province: selectProvince,
	cities: selectCities,
	listProvince: selectListProvince,
});
const mapDispatchToProps = (dispatch) => ({
	setListProvince: (list) => dispatch(SetListProvince(list)),
	setCities: (city) => dispatch(SetCities(city)),
});
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AgenciesListComponent);
